import styled from 'styled-components';

export const ActionFooterContainer = styled.div`
  display: flex;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 12px 24px 0 24px;
  justify-content: space-between;
  align-items: center;
  min-height: 60px;
  border-radius: 0 0 10px 10px;
  background: ${({ theme }) => theme.colors.primary.white};
  box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.03);
`;

export const FooterButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  .ant-btn {
    color: ${({ theme }) => theme.colors.primary.blue};
    cursor: pointer;
    padding: 0;
    border: none;
    box-shadow: none;
    display: flex;
    gap: 8px;
    align-items: center;
  }
  .line {
    display: flex;
    align-items: center;
    width: 1px;
    height: 12px;
    background-color: ${({ theme }) => theme.colors.grayVariations.medium};
  }
`;
